import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ElementoMenuHijo } from './elemento-menu-hijo';

@Component({
  selector: 'app-panel-menu',
  templateUrl: './panel-menu.component.html',
  styleUrl: './panel-menu.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PanelMenuComponent implements OnInit, OnDestroy {
  @Input() elementosHijos!: ElementoMenuHijo[] | null;
  @Input() descripcionOpcionMenu!: string | null;
  @Input() widget!: string | null;
  @Output() elementoHijoSeleccionado = new EventEmitter<ElementoMenuHijo>();
  abierto: boolean = false;
  private clickListener: any;

  constructor(public elementRef: ElementRef) {}

  ngOnInit() {
    this.manejarClickFueraMenu();
  }

  ngOnDestroy() {
    if (this.clickListener) {
      document.removeEventListener('click', this.clickListener);
    }
  }

  private manejarClickFueraMenu() {
    this.clickListener = (event: MouseEvent) => {
      if (!this.abierto) return;

      if (this.elementRef.nativeElement.contains(event.target)) return;

      const menuElement = document.querySelector('app-menu');
      if (menuElement && menuElement.contains(event.target as Node)) return;

      this.abierto = false;
      this.elementoHijoSeleccionado.emit();
    };

    document.addEventListener('click', this.clickListener);
  }

  cerrarPanel() {
    this.elementoHijoSeleccionado.emit();
  }
}
